const enumValue = description => Object.freeze({
    toString: () => description
});

export const NAME = enumValue('NAME');
export const DATE_UPLOADED = enumValue('DATE_UPLOADED');
export const NO_SORT = enumValue('');